export default "__VITE_ASSET__D0A91ZEf__"